// hms.id.fe.provider/src/_metronic/store/notificationStore.ts
import {create} from 'zustand'

// File update notification
interface FileNotification {
  type: 'file'
  ClaimNumber: string
  Status: string
  UpdatedBy: string
  UpdatedAt: string
  isRead: boolean
}

// Chat notification
interface ChatNotification {
  type: 'chat'
  claimNumber: string
  insurerName: string
  customerName: string
  remark: string
  documentName: string[]
  role: string
  createdBy: string
  createdAt: string
  updatedBy: string
  updatedAt: string
  chatIsOpen: boolean
  isRead: boolean
}

// Status update notification
interface StatusNotification {
  type: 'status'
  ClaimNumber: string
  StatusClaim: string
  createdAt: string
  isRead: boolean
}

type Notification = FileNotification | ChatNotification | StatusNotification

interface NotificationStore {
  notifications: Notification[]
  hasViewedNotifications: boolean
  addNotification: (notification: Notification) => void
  clearNotifications: () => void
  markAsRead: (index: number) => void
  markAllAsRead: () => void
  unreadCount: number
  resetUnreadCount: () => void
  setHasViewedNotifications: (viewed: boolean) => void
}

const useNotificationStore = create<NotificationStore>((set, get) => ({
  notifications: [],
  unreadCount: 0,
  hasViewedNotifications: false,

  addNotification: (notification) =>
    set((state) => ({
      notifications: [...state.notifications.slice(-50), notification],
      unreadCount: state.hasViewedNotifications ? 1 : state.unreadCount + 1,
      hasViewedNotifications: false,
    })),

  resetUnreadCount: () =>
    set({
      unreadCount: 0,
      hasViewedNotifications: true,
    }),

  clearNotifications: () => set({notifications: [], unreadCount: 0}),

  markAsRead: (index) =>
    set((state) => {
      const notifications = [...state.notifications]
      if (notifications[index] && !notifications[index].isRead) {
        notifications[index].isRead = true
        return {notifications, unreadCount: state.unreadCount - 1}
      }
      return {notifications}
    }),

  markAllAsRead: () =>
    set((state) => ({
      notifications: state.notifications.map((notif) => ({
        ...notif,
        isRead: true,
      })),
      unreadCount: 0,
    })),

  setHasViewedNotifications: (viewed) => set({hasViewedNotifications: viewed}),
}))

export default useNotificationStore
